import { WidgetConfiguration } from "@/interfaces/widgetConfiguration";
import { WidgetPayload } from "@/interfaces/widgetPayload";
import { WidgetState } from "@/interfaces/widgetState";
import { Layout } from "@/interfaces/layout";
import { StudioAttributes } from "@/interfaces/studioAttributes";
import { loadPlugin } from "@/plugins/vue-socket-io";
import { Socket } from "socket.io-client";
import BackgroundSettings from "@/interfaces/studioBackground";

export class SocketService {
    protected static socketClient: Socket = loadPlugin().client;

    public static async joinStudio(
        studioId: string,
        token: string | { id: string; username: string; email: string }
    ) {
        this.socketClient.emit("join_studio", {
            studioId,
            token,
        });
    }

    public static leaveStudio(studioId: string) {
        this.socketClient.emit("leave_studio", { studioId });
    }

    public static updateLayout(studioId: string, layout: Layout[]) {
        this.socketClient.emit("layout_update", {
            studioId,
            layout,
        });
    }

    public static updateAttributes(
        studioId: string,
        attributes: Partial<StudioAttributes>
    ) {
        this.socketClient.emit("attributes_update", {
            studioId,
            attributes,
        });
    }

    public static updateBackground(
        studioId: string,
        background: BackgroundSettings | null
    ) {
        this.socketClient.emit("update_background", {
            studioId,
            background,
        });
    }

    public static updateWidgetState<
        TConfig extends WidgetConfiguration<TState, TPayload>,
        TState = TConfig extends WidgetConfiguration<
            infer _TState,
            WidgetPayload
        >
        ? _TState
        : WidgetState,
        TPayload = TConfig extends WidgetConfiguration<
            WidgetState,
            infer _TPayload
        >
        ? _TPayload
        : WidgetPayload
    >(
        studioId: string, // Debug: muss noch abgesichert werden
        config: TConfig,
        payload: TPayload
    ) {
        this.socketClient.emit("widget_update", {
            widgetId: config.widgetId,
            type: config.type,
            studioId,
            payload,
        });
    }

    public static addWidget(
        studioId: string,
        type: string,
        layout: Omit<Layout, "i">
    ) {
        this.socketClient.emit("widget_add", {
            type,
            studioId,
            layout,
        });
    }

    public static removeWidget(studioId: string, widgetId: string) {
        this.socketClient.emit("widget_remove", {
            studioId,
            widgetId,
        });
    }

    public static widgetConfigUpdate(
        studioId: string,
        widgetConfig: WidgetConfiguration<WidgetState, WidgetPayload>[]
    ) {
        this.socketClient.emit("widgetConfig_update", {
            studioId,
            widgetConfig,
        });
    }
    public static async participantInfoRequest(studioId: string) {
        this.socketClient.emit("participantInfo_request", {
            studioId,
        });
    }
}
